import React from "react";

function SMOverdueHeatmap({ data, loading, error, onCellClick }) {
  const rows = Array.isArray(data?.rows) ? data.rows : [];
  const dayLabels = Array.isArray(data?.dayLabels)
    ? data.dayLabels
    : ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const reps = new Map();
  for (const r of rows) {
    if (!reps.has(r.user_id)) {
      reps.set(r.user_id, {
        user_id: r.user_id,
        full_name: r.full_name,
        days: Array(7).fill(0),
      });
    }
    reps.get(r.user_id).days[Number(r.day_idx)] = Number(r.overdue_count || 0);
  }

  const repList = Array.from(reps.values());
  const maxCount = Math.max(1, ...rows.map((r) => Number(r.overdue_count || 0)));

  const cellBg = (count) => {
    if (count === 0) return "#f5f8fc";
    const intensity = Math.min(count / maxCount, 1);
    const alpha = 0.15 + intensity * 0.7;
    return `rgba(217, 119, 6, ${alpha})`;
  };

  return (
    <div className="dashboard-card-v2">
      <div className="dashboard-card-v2-header">
        <i className="fas fa-fire" />
        <span>Overdue Heatmap</span>
        <span className="dashboard-card-v2-count">Last {data?.windowDays || 30} days</span>
      </div>
      <div className="dashboard-card-v2-body">
        {error ? (
          <div className="dashboard-error">
            <i className="fas fa-exclamation-circle" /> {error}
          </div>
        ) : loading ? (
          <div className="dashboard-skeleton-block" style={{ height: 200 }} />
        ) : repList.length === 0 ? (
          <div className="dashboard-empty">
            <i className="fas fa-check-circle" />
            <p>No overdue activity in this window.</p>
          </div>
        ) : (
          <div className="sm-heatmap">
            <div className="sm-heatmap-header">
              <span />
              {dayLabels.map((d) => (
                <span key={d} className="sm-heatmap-daylabel">{d}</span>
              ))}
            </div>
            {repList.map((rep) => (
              <div key={rep.user_id} className="sm-heatmap-row">
                <button
                  type="button"
                  className="sm-heatmap-name sm-heatmap-name-clickable"
                  title={`${rep.full_name} — click to view all overdue`}
                  onClick={() => onCellClick && onCellClick(rep)}
                >
                  {rep.full_name}
                </button>
                {rep.days.map((count, i) => (
                  <button
                    key={i}
                    type="button"
                    className="sm-heatmap-cell sm-heatmap-cell-clickable"
                    style={{ background: cellBg(count) }}
                    title={`${rep.full_name} — ${dayLabels[i]}: ${count} overdue (click to view all of their overdue)`}
                    onClick={() => onCellClick && onCellClick(rep)}
                  >
                    {count > 0 ? count : ""}
                  </button>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default SMOverdueHeatmap;